import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class CommonServices {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * Shows a snackbar message with optional configuration.
   * @param type Message type ('success' | 'error' | 'info' | 'warning')
   * @param message Message text to show
   * @param duration Duration in seconds (default: 2s)
   * @param verticalPosition 'top' or 'bottom' (default: 'top')
   */
  showMessage(
    type: 'success' | 'error' | 'info' | 'warning' | 'Error' | 'X' | 'Success' | 'Welcome' | 'eror',
    message: string,
    duration: number = 20000,
    verticalPosition: 'top' | 'bottom' = 'top'
  ): void {
    const kind = String(type || 'info').toLowerCase();
    const tone = kind === 'x' || kind === 'eror' ? 'error' : kind;
    const config: MatSnackBarConfig = {
      duration: duration * 1000,
      verticalPosition: verticalPosition,
      horizontalPosition: 'center',
      panelClass: ['casino-snackbar', `${tone}-snackbar`]
    };

    if (tone === 'error') {
      console.error('[HostToast]', message);
    }

    this.snackBar.open(message, 'OK', config);
  }

  friendlyAddressValidationMessage(
    errorMessage?: string,
    extras?: {
      dpvDescription?: string;
      suggestedStreetAddress?: string;
      suggestedCity?: string;
      suggestedState?: string;
      suggestedZipCode?: string;
    }
  ): string {
    const fallback = 'We could not validate this address. Please check the street, city, state, and ZIP code and try again.';
    const raw = (errorMessage || '').trim();
    const lower = raw.toLowerCase();
    let message = fallback;

    if (!raw) {
      message = fallback;
    } else if (lower.includes('streetaddress') || (lower.includes('street') && lower.includes('required'))) {
      message = 'Please enter a complete street address, including the house number and street name.';
    } else if (lower.includes('zipcode') && (lower.includes('required') || lower.includes('invalid'))) {
      message = 'Please enter a valid 5-digit ZIP code.';
    } else if (lower.includes('oasvalidation') || lower.includes('apiversion') || raw.includes('{')) {
      message = fallback;
    } else if (raw.length > 160) {
      message = fallback;
    } else {
      message = raw;
    }

    if (extras?.dpvDescription && /not deliverable|apartment|suite/i.test(extras.dpvDescription)) {
      message += ' ' + extras.dpvDescription;
    }
    if (extras?.suggestedStreetAddress) {
      message += ' Suggested: ' + extras.suggestedStreetAddress + ', ' +
        extras.suggestedCity + ', ' + extras.suggestedState + ' ' + extras.suggestedZipCode;
    }
    return message;
  }
}
